import React from "react";
import RailsFormGenericInput from "./RailsFormGenericInput";

export default class RailsFormSelectInput extends RailsFormGenericInput{

  render(){
    return (<div className="form-group row">
      <label className="col-sm-4 col-form-label">{this.props.label ? this.props.label : this.props.attribute_name }</label>
      <div className="col-sm-8">
        <select
          className="form-control"
          type="text"
          name={`${this.props.model_name}[${this.props.attribute_name}]`}
          id={`${this.props.model_name}_${this.props.attribute_name}`}
          value={this.props.value}
          onChange={ this.onValueChange }
        >
          {this.props.options.map( (opt) => {
          return <option value={opt} key={opt}>{opt}</option>;
          })}
        </select>
      </div>
    </div>);
  }
}